import { render, staticRenderFns } from "./timesheet-exp-panels-skeleton-loader.vue?vue&type=template&id=58d35856&scoped=true&"
import script from "./timesheet-exp-panels-skeleton-loader.vue?vue&type=script&lang=js&"
export * from "./timesheet-exp-panels-skeleton-loader.vue?vue&type=script&lang=js&"
import style0 from "./timesheet-exp-panels-skeleton-loader.vue?vue&type=style&index=0&id=58d35856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d35856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
